<template>
    <main class="fashion-view">
        <header class="cover fashion-cover">
            <div class="cover-bg" :style="styles.coverBg" v-parallax="0.3"></div>
            <div class="cover-content" v-parallax="0.15">
                <h1 class="cover-title">{{ $t('pages.fashion.title') }}</h1>
                <h2 class="cover-subtitle">{{ $t('pages.fashion.subtitle') }}</h2>
            </div>
        </header>
        <div class="body">
            <section>
                <v-waypoint class="vue-waypoint__waypoint--top" @waypoint-in="updateInPageNav('#ruyi-brand-network', 'down')"></v-waypoint>
                <div id="ruyi-brand-network" class="text-block text-block-01">
                    <h3 class="text-block-title text-block-title-underline">{{ $t('pages.fashion.text-block-01.title') }}</h3>
                    <div class="text-block-body">
                        <p v-html="$t('pages.fashion.text-block-01.body')"></p>
                    </div>
                </div>
                <v-waypoint class="vue-waypoint__waypoint--bottom" @waypoint-in="updateInPageNav('#ruyi-brand-network', 'up')"></v-waypoint>
            </section>
            <section>
                <v-waypoint class="vue-waypoint__waypoint--top" @waypoint-in="updateInPageNav('#smcp', 'down')"></v-waypoint>
                <div class="text-block text-block-02">
                    <h3 class="text-block-title text-block-title-underline px-0" v-html="$t('pages.fashion.text-block-04.title')"></h3>
                </div>
                <div class="image-block image-block-01">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image01.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image01.md}`" />
                        <img :src="`${assets.image01.xs}`"/>
                    </picture>
                </div>
                <div class="image-block image-block-02">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image02.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image02.md}`" />
                        <img :src="`${assets.image02.xs}`">
                    </picture>
                </div>
                <div id="smcp" class="text-block text-block-03">
                    <div class="text-block-body">
                        <h4 class="brand" v-html="$t('pages.fashion.text-block-03.title')"></h4>
                        <p v-html="$t('pages.fashion.text-block-03.body')"></p>
                        <br>
                        <p><a class="font-weight-bold" :href="$t('pages.fashion.text-block-03.website')" target="_blank">{{ $t('pages.fashion.text-block-03.website') }} <i class="iconfont icon-angle-right iconfont-lg"></i></a></p>
                    </div>
                </div>
                <v-waypoint class="vue-waypoint__waypoint--bottom" @waypoint-in="updateInPageNav('#smcp', 'up')"></v-waypoint>
            </section>
            <section>
                <v-waypoint class="vue-waypoint__waypoint--top" @waypoint-in="updateInPageNav('#renown', 'down')"></v-waypoint>
                <div class="text-block text-block-04">
                    <h3 class="text-block-title text-block-title-underline px-0" v-html="$t('pages.fashion.text-block-04.title')"></h3>
                </div>
                <div class="image-block image-block-03">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image03.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image03.md}`" />
                        <img :src="`${assets.image03.xs}`"/>
                    </picture>
                </div>
                <div class="image-block image-block-04">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image04.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image04.md}`" />
                        <img :src="`${assets.image04.xs}`">
                    </picture>
                </div>
                <div id="renown" class="text-block text-block-05">
                    <div class="text-block-body">
                        <h4 class="brand" v-html="$t('pages.fashion.text-block-05.title')"></h4>
                        <p v-html="$t('pages.fashion.text-block-05.body')"></p>
                        <br>
                        <p><a class="font-weight-bold" :href="$t('pages.fashion.text-block-05.website')" target="_blank">{{ $t('pages.fashion.text-block-05.website') }} <i class="iconfont icon-angle-right iconfont-lg"></i></a></p>
                    </div>
                </div>
                <div class="image-block image-block-05 d-none d-md-block">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image05.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image05.md}`" />
                        <img>
                    </picture>
                </div>
                <v-waypoint class="vue-waypoint__waypoint--bottom" @waypoint-in="updateInPageNav('#renown', 'up')"></v-waypoint>
            </section>
        </div>
        <in-page-nav :links="inPageLinks" :active="inPageNavActive" />
    </main>
</template>

<script>
  import InPageNav from '../widgets/InPageNav.vue'
  import getMatchedBreakpoint from '../mixins/getMatchedBreakpoint'
  import updateHead from '../mixins/updateHead'
  import updateInPageNav from '../mixins/updateInPageNav'

  export default {
    computed: {
      styles () {
        return {
          coverBg: {
            backgroundImage: `url(${this.assets.cover[this.matchedBreakpoint]})`
          }
        }
      },
      assets () {
        return {
          cover: {
            xs: this.$t('pages.fashion.cover.xs'),
            md: this.$t('pages.fashion.cover.md'),
            xl: this.$t('pages.fashion.cover.xl')
          },
          image01: {
            xs: this.$t('pages.fashion.image-block-01.xs'),
            md: this.$t('pages.fashion.image-block-01.md'),
            xl: this.$t('pages.fashion.image-block-01.xl')
          },
          image02: {
            xs: this.$t('pages.fashion.image-block-02.xs'),
            md: this.$t('pages.fashion.image-block-02.md'),
            xl: this.$t('pages.fashion.image-block-02.xl')
          },
          image03: {
            xs: this.$t('pages.fashion.image-block-03.xs'),
            md: this.$t('pages.fashion.image-block-03.md'),
            xl: this.$t('pages.fashion.image-block-03.xl')
          },
          image04: {
            xs: this.$t('pages.fashion.image-block-04.xs'),
            md: this.$t('pages.fashion.image-block-04.md'),
            xl: this.$t('pages.fashion.image-block-04.xl')
          },
          image05: {
            md: this.$t('pages.fashion.image-block-05.md'),
            xl: this.$t('pages.fashion.image-block-05.xl')
          }
        }
      },
      inPageLinks () {
        return [
          {
            title: this.$t('pages.fashion.text-block-01.title'),
            hash: '#ruyi-brand-network'
          },
          {
            title: 'SMCP',
            hash: '#smcp'
          },
          {
            title: 'RENOWN',
            hash: '#renown'
          }
        ]
      }
    },
    head: {
      title () {
        return {
          inner: this.$t('pages.fashion.title'),
          complement: this.$t('common.ruyi-group')
        }
      }
    },
    components: {
      InPageNav
    },
    mixins: [
      getMatchedBreakpoint,
      updateHead,
      updateInPageNav
    ]
  }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .fashion-view {
        .text-block {
            .brand {
                font-size: px2rem(24px);
                font-style: italic;
                font-weight: normal;
                margin-bottom: 1rem;

                @include media-breakpoint-up(md) {
                    background-color: $body-bg;
                    padding-left: 1rem;
                    padding-right: 1rem;
                    position: absolute;
                }

                @include media-breakpoint-up(xl) {
                    font-size: px2rem(48px);
                }

                > small {
                    font-size: px2rem(15px);

                    @include media-breakpoint-up(xl) {
                        font-size: px2rem(30px);
                    }
                }
            }

            &-01 {
                .text-block-body {
                    width: px2rem(280px);

                    @include media-breakpoint-up(md) {
                        width: px2rem(580px);
                    }

                    @include media-breakpoint-up(xl) {
                        width: px2rem(1086px);
                    }
                }
            }

            &-02 {
                @include media-breakpoint-up(md) {
                    margin-left: px2rem(100px);
                    margin-top: 1rem;
                    padding: 0;
                    position: absolute;
                }

                @include media-breakpoint-up(xl) {
                    margin-left: px2rem(150px);
                    margin-top: 2rem;
                }

                .text-block-title {
                    padding-bottom: px2rem(10px);
                    max-width: none;

                    @include media-breakpoint-up(xl) {
                        padding-bottom: px2rem(20px);
                    }

                    > img {
                        width: 200px;

                        @include media-breakpoint-up(md) {
                            width: 150px;
                        }

                        @include media-breakpoint-up(xl) {
                            width: 300px;
                        }
                    }
                }
            }

            &-03 {
                @include media-breakpoint-up(md) {
                    border: 1px solid $black;
                    margin-bottom: px2rem(100px);
                    margin-left: px2rem(270px);
                    margin-right: px2rem(50px);
                    margin-top: px2rem(-180px);
                    padding-bottom: px2rem(30px);
                    padding-left: px2rem(120px);
                    padding-top: px2rem(45px);
                }

                @include media-breakpoint-up(xl) {
                    margin-left: px2rem(470px);
                    margin-right: px2rem(80px);
                    margin-top: px2rem(-300px);
                    padding-bottom: px2rem(60px);
                    padding-left: px2rem(150px);
                    padding-top: px2rem(75px);
                }

                .text-block-body {
                    position: relative;
                    width: px2rem(280px);

                    @include media-breakpoint-up(md) {
                        align-self: left;
                        max-width: px2rem(560px);
                        min-width: px2rem(280px);
                        text-align: left;
                        width: calc(100% - 90px);
                    }

                    @include media-breakpoint-up(xl) {
                        min-width: px2rem(480px);
                        max-width: px2rem(960px);
                        width: calc(100% - 150px);
                    }

                    .brand {
                        left: -1rem;
                        top: px2rem(-68px);

                        @include media-breakpoint-up(xl) {
                            top: px2rem(-120px);
                        }
                    }
                }
            }

            &-04 {
                @include media-breakpoint-up(md) {
                    margin-left: px2rem(100px);
                    margin-top: 7rem;
                    padding: 0;
                    position: absolute;
                }

                @include media-breakpoint-up(xl) {
                    margin-left: px2rem(150px);
                    margin-top: 12rem;
                }

                .text-block-title {
                    padding-bottom: px2rem(10px);
                    max-width: none;

                    @include media-breakpoint-up(xl) {
                        padding-bottom: px2rem(20px);
                    }

                    > img {
                        width: 200px;

                        @include media-breakpoint-up(md) {
                            width: 150px;
                        }

                        @include media-breakpoint-up(xl) {
                            width: 300px;
                        }
                    }
                }
            }

            &-05 {
                @include media-breakpoint-up(md) {
                    border: 1px solid $black;
                    margin-bottom: px2rem(100px);
                    margin-left: px2rem(270px);
                    margin-right: px2rem(50px);
                    margin-top: px2rem(-180px);
                    padding-bottom: px2rem(30px);
                    padding-left: px2rem(120px);
                    padding-top: px2rem(45px);
                }

                @include media-breakpoint-up(xl) {
                    margin-left: px2rem(470px);
                    margin-right: px2rem(80px);
                    margin-top: px2rem(-300px);
                    padding-bottom: px2rem(60px);
                    padding-left: px2rem(150px);
                    padding-top: px2rem(75px);
                }

                .text-block-body {
                    position: relative;
                    width: px2rem(280px);

                    @include media-breakpoint-up(md) {
                        align-self: left;
                        max-width: px2rem(560px);
                        min-width: px2rem(280px);
                        text-align: left;
                        width: calc(100% - 90px);
                    }

                    @include media-breakpoint-up(xl) {
                        min-width: px2rem(480px);
                        max-width: px2rem(960px);
                        width: calc(100% - 150px);
                    }

                    .brand {
                        left: -1rem;
                        top: px2rem(-68px);

                        @include media-breakpoint-up(xl) {
                            top: px2rem(-120px);
                        }
                    }
                }
            }
        }

        .image-block {
            &-01 {
                width: 65%;
                margin-left: auto;
                position: relative;
                z-index: 1;

                @include media-breakpoint-up(md) {
                    position: static;
                    width: px2rem(530px);
                    z-index: auto;
                }

                @include media-breakpoint-up(xl) {
                    width: px2rem(883px);
                }
            }

            &-02 {
                margin-top: px2rem(-50px);

                @include media-breakpoint-up(md) {
                    margin-top: px2rem(-175px);
                    width: px2rem(340px);
                }

                @include media-breakpoint-up(xl) {
                    margin-top: px2rem(-290px);
                    width: px2rem(567px);
                }
            }

            &-03 {
                width: 65%;
                margin-left: auto;
                position: relative;
                z-index: 1;

                @include media-breakpoint-up(md) {
                    position: static;
                    width: px2rem(568px);
                    z-index: auto;
                }

                @include media-breakpoint-up(xl) {
                    width: px2rem(946px);
                }
            }

            &-04 {
                margin-top: px2rem(-50px);

                @include media-breakpoint-up(md) {
                    margin-top: px2rem(-130px);
                    width: px2rem(332px);
                }

                @include media-breakpoint-up(xl) {
                    margin-top: px2rem(-215px);
                    width: px2rem(553px);
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// Fashion.vue?1734e816